<app-navbar-style-two></app-navbar-style-two>
<app-partner></app-partner>

<!-- Start Page Title Area -->
<div class="page-title-area" *ngFor="let Content of pageTitle;" style="background-image: url({{Content.bgImage}});">
    <h1>{{Content.title}}</h1>
    <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{Content.title}}</li>
    </ul>
</div>
<!-- End Page Title Area -->

<!-- Start Careers Area -->
<section class="careers-area pt-100 pb-70">
    <div class="container">
        <div class="careers-content" *ngFor="let Content of careersContent;">
            <div class="section-header text-center">
                <div class="section-badge">{{Content.subTitle}}</div>
                <h2 class="section-title">{{Content.title}}</h2>
                <p class="section-description">{{Content.paragraph}}</p>
            </div>

            <!-- Benefits Section -->
            <div class="row mb-5">
                <div class="col-lg-3 col-md-6 mb-4" *ngFor="let benefit of benefits;">
                    <div class="benefit-card">
                        <div class="benefit-icon">
                            <i class="bx" [ngClass]="benefit.icon"></i>
                        </div>
                        <h4>{{benefit.title}}</h4>
                        <p>{{benefit.description}}</p>
                    </div>
                </div>
            </div>

            <!-- Open Positions -->
            <div class="positions-section">
                <h3 class="positions-title">Current Openings</h3>
                <div class="row">
                    <div class="col-lg-6 mb-4" *ngFor="let position of openPositions;">
                        <div class="position-card">
                            <div class="position-header">
                                <h4>{{position.title}}</h4>
                                <span class="position-type">{{position.type}}</span>
                            </div>
                            <div class="position-meta">
                                <span><i class="bx bx-briefcase"></i> {{position.department}}</span>
                                <span><i class="bx bx-map"></i> {{position.location}}</span>
                                <span><i class="bx bx-time"></i> {{position.experience}}</span>
                            </div>
                            <p class="position-description">{{position.description}}</p>
                            <div class="position-requirements">
                                <h5>Requirements:</h5>
                                <ul>
                                    <li *ngFor="let req of position.requirements">
                                        <i class="bx bx-check"></i> {{req}}
                                    </li>
                                </ul>
                            </div>
                            <button class="apply-btn" data-bs-toggle="modal" data-bs-target="#enquireModal">
                                <i class="bx bx-send"></i> Apply Now
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- No Positions -->
            <div class="text-center py-5" *ngIf="openPositions.length === 0">
                <i class="bx bx-briefcase" style="font-size: 64px; color: #ccc;"></i>
                <p class="mt-3 text-muted">No open positions at the moment. Please check back later.</p>
            </div>
        </div>
    </div>
</section>
<!-- End Careers Area -->

<app-testimonials></app-testimonials>
